import FakeFranchiseApi from "./FakeFranchiseApi";
import RealFranchiseApi from "./RealFranchiseApi";
import CommonRequestBodyDto from "../dto/common/CommonRequestBodyDto";
import FranchiseSaveReqDto from "../dto/franchise/FranchiseSaveReqDto";
import FranchiseUpdateReqDto from "../dto/franchise/FranchiseUpdateReqDto";

class FranchiseApi {
    fakeApi = false;
    fake = new FakeFranchiseApi();
    real = new RealFranchiseApi();

    getFranchiseList = ({
        page,
        pageSize,
        franchiseCode,
        franchiseName,
    }: {
        page: number;
        pageSize: number;
        franchiseCode: string;
        franchiseName: string;
    }) => {
        if (this.fakeApi) {
            return this.fake.getFranchiseList({ page, pageSize, franchiseCode, franchiseName });
        } else {
            return this.real.getFranchiseList({ page, pageSize, franchiseCode, franchiseName });
        }
    };

    saveFranchise = (reqDto: CommonRequestBodyDto<FranchiseSaveReqDto>) => {
        if (this.fakeApi) {
            return this.fake.saveFranchise();
        } else {
            return this.real.saveFranchise(reqDto);
        }
    };

    getFranchiseInfo = ({ countryCode, franchiseCode }: { countryCode: string; franchiseCode: string }) => {
        if (this.fakeApi) {
            return this.fake.getFranchiseInfo();
        } else {
            return this.real.getFranchiseInfo({ countryCode, franchiseCode });
        }
    };

    updateFranchise = (reqDto: CommonRequestBodyDto<FranchiseUpdateReqDto>) => {
        if (this.fakeApi) {
            return this.fake.updateFranchise();
        } else {
            return this.real.updateFranchise(reqDto);
        }
    };

    deleteFranchise = ({ idFranchise }: { idFranchise: number }) => {
        if (this.fakeApi) {
            return this.fake.deleteFranchise();
        } else {
            return this.real.deleteFranchise({ idFranchise });
        }
    };

    checkFranchiseCode = ({ franchiseCode, countryCode }: { franchiseCode: string; countryCode: string }) => {
        if (this.fakeApi) {
            return this.fake.checkFranchiseCode();
        } else {
            return this.real.checkFranchiseCode({ franchiseCode, countryCode });
        }
    };
}

export default FranchiseApi;
